import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { UserRolesService } from '../../services/user-roles.service';
import { LicenseService } from '../../services/license.service';
declare var bootstrap: any; // Para usar Bootstrap puro
import Swal from 'sweetalert2';


@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss']
})
export class AdminUsersComponent implements OnInit {
  users: any[] = [];
  roles: any[] = [];
  licenses: any[] = [];
  userForm: FormGroup;
  isEdit = false;
  selectedUserId: string | null = null;
  modalInstance: any;
  showPassword: boolean = false;

  // Paginación
  currentPage: number = 1;
  pageSize: number = 10;
  totalUsers: number = 0;
  totalPages: number = 0; // Ahora tomamos esto desde la API

  // Filtros de búsqueda
  name: string = '';
  email: string = '';
  rut: string = '';
  user_role: string = '';
  missionary_license: string = '';

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private userRolesService: UserRolesService,
    private licenseService: LicenseService
  ) {
    this.userForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      rut: ['', [Validators.required, Validators.pattern(/^\d{7,8}-[kK\d]$/)]],
      employee_code: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      user_role: ['', Validators.required],
      missionary_license: [],
      password: ['', Validators.minLength(6)],
      active: [true]
    });
  }

  ngOnInit() {
    this.loadUsers();
    this.loadRoles();
    this.loadLicenses();
  }

  loadUsers() {
    this.userService.getView({
      page: this.currentPage,
      limit: this.pageSize,
      name: this.name,
      email: this.email,
      rut: this.rut,
      user_role: this.user_role,
      missionary_license: this.missionary_license
    }).subscribe(response => {
      this.users = response.users;
      this.totalUsers = response.total;
      this.totalPages = response.totalPages;
    });
  }

  onPageSizeChange() {
    this.currentPage = 1; // Reiniciar a la primera página
    this.loadUsers(); // Recargar los usuarios con el nuevo pageSize
  }

  onSearch() {
    this.currentPage = 1; // Reiniciar la paginación en la primera página
    this.loadUsers();
  }
  getPaginationArray(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  changePage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.loadUsers();
  }
  openEditModal(user: any) {
    this.isEdit = true;
    this.selectedUserId = user._id;

    this.userForm.patchValue({
      name: user.name,
      rut: user.rut,
      employee_code: user.employee_code,
      email: user.email,
      user_role: user.user_role ? user.user_role._id : null,
      missionary_license: user.missionary_license ? user.missionary_license._id : null,
      password: '', // No se muestra la contraseña por seguridad
      active: user.active
    });

    this.openModal();
  }

  openModal() {
    let modalElement = document.getElementById('userModal');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement);
      this.modalInstance.show();
    }
  }

  openCreateModal() {
    this.isEdit = false;
    this.selectedUserId = null;
    this.userForm.reset();
    this.userForm.patchValue({active: true});
    this.openModal();
  }

  loadRoles() {
    this.userRolesService.get().subscribe(data => {
      this.roles = data;
    });
  }

  loadLicenses() {
    this.licenseService.get().subscribe(data => {
      this.licenses = data;
    });
  }
  removeModalBackdrop() {
    const modalBackdrops = document.getElementsByClassName('modal-backdrop');
    while (modalBackdrops.length > 0) {
      modalBackdrops[0].parentNode?.removeChild(modalBackdrops[0]);
    }
  }

  closeModal() {
    let modalElement = document.getElementById('userModal');
    if (modalElement) {
      let modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
    this.removeModalBackdrop();
  }

  saveUser() {
    if (this.userForm.invalid) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Por favor, completa todos los campos requeridos correctamente.'
      });
      return;
    }

    Swal.fire({
      title: 'Guardando usuario',
      text: 'Por favor, espera un momento...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    const userData = { ...this.userForm.value };
    if (this.isEdit && this.selectedUserId) {
      if (!userData.password || userData.password.trim() === '') {
        delete userData.password;
      }
      // Editar usuario
      this.userService.update(this.selectedUserId, userData).subscribe({
        next: () => {
          this.loadUsers();
          this.closeModal();
          Swal.close();
          Swal.fire({
            icon: 'success',
            title: 'Exito',
            text: 'Cambios Guardados para el usuario'
          });
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al actualizar el usuario'
          });
        }
      });
    } else {
      // Crear usuario
      this.userService.save(userData).subscribe({
        next: () => {
          Swal.close();
          this.loadUsers();
          this.closeModal();
          Swal.fire({
            icon: 'success',
            title: 'Exito',
            text: 'Se ha creado correctamente el usuario'
          });
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al crear el usuario'
          });
        }
      });
    }
  }

} 